module.exports = __webpack_public_path__ + "r-v3/img/user_device_tablet.bf6e19ee.svg";